import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { useHighFrequencyRefreshQuery } from '../../../queryDefaults/baseQueries/useHighFrequencyRefreshQuery';
import { Collaborator, ICollaborator } from '../Collaborator.ts';
import { CollaboratorApi } from '../../../apis/CollaboratorApi/CollaboratorApi.ts';

export function useGetPatientCollaboratorSummaries(patientId: string | undefined) {
    return useHighFrequencyRefreshQuery({
        queryKey: [QueryKeys.collaborator, patientId],
        queryFn: async () => {
            const result: ICollaborator[] = await CollaboratorApi.getPatientCollaboratorSummaries(patientId!);
            return result?.map((x) => new Collaborator(x)) ?? [];
        },
        enabled: !!patientId && patientId != '0',
    });
}
